
<template>
  <span>{{time}}</span>
</template>
<script>
export default {
  props: ['date', 'fmt'],
  data () {
    return {
      time: ''
    }
  },
  watch: {
    date() {
      this.textChange()
    }
  },
  methods: {
    formatDate (date, fmt) {
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
      }
      let o = {
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds()
      }
      for (let k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
          let str = o[k] + ''
          fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : this.padLeftZero(str))
        }
      }
      return fmt
    },
    padLeftZero (str) {
      return ('00' + str).substr(str.length)
    },
    textChange () {
      let str = this.date
      if (typeof (str) === 'string') {
        str = str.replace(/-/g, '/')
      }
      const date = new Date(str)
      const fmt = this.fmt ? this.fmt : 'yyyy-MM-dd hh:mm:ss'
      this.time = str ? this.formatDate(date, fmt) : '未知'
    }
  },
  mounted () {
    this.textChange()
  }
}
</script>
